import { useEffect, useId } from "react";

/**
 * Inject a JSON-LD <script> tag into <head> for the lifetime of a page.
 * Search engines (Google, Bing) render JS and pick this up.
 *
 * Usage:
 *   <JsonLd data={{ "@context": "https://schema.org", "@type": "BlogPosting", ... }} />
 */
export default function JsonLd({ data, id }) {
  const reactId = useId();
  const scriptId = id || `jsonld-${reactId.replace(/[:]/g, "")}`;

  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = scriptId;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [data, scriptId]);

  return null;
}
